<template>
<div class="CreateGroupDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="close-text-font-style margin-right-1Perc margin-Top-1Perc margin-bottom-5Perc cursor-pointer " v-on:click="updateHideCreateGroupOverlayFlag($event,true)">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon">
                  </div>  
                </div>
              </div>

            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Group Name
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="text" class="form-control" v-model="groupName">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  IsPublic
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="checkbox" class="float-left" v-model="getIsPublicValue"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>

            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Max Elective Enrollment Count
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="number" placeholder="MAX" min="0" class="form-control" v-model="getMaxElectiveEnrollmentCount">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Cohort Name
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="text" class="form-control" v-model="getCohortName" :disabled="getMaxElectiveEnrollmentCount === 0">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>

            <hr width="94%" size="10px">
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-10 col-lg-10">
                  <b>LEAPS</b>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Min Action Count
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="number" placeholder="MAX" min="0" class="form-control" v-model="getMinActionCountValue">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Max Action Count
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="number" placeholder="MAX" min="0" class="form-control" v-model="getMaxActionCountValue">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>
            
            <hr width="94%" size="10px">
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Show Custom Unreleased Lesson Msg
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="checkbox" v-model="getShowUnreleasedModuleMessage"/>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Unreleased Lesson Msg
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="text" class="form-control" v-model="getUnreleasedModuleMessage" :maxlength="constants.Unrelease_Lesson_Msg_Max_Length" :disabled="!getShowUnreleasedModuleMessage">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>
            <hr width="94%" size="10px" v-if="false">
            <div class="row vertical-align margin-bottom-2Perc" v-if="false">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-left-0Px text-align-right">
                  Automatically show certificates to Users:
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="checkbox" v-model="allowViewCertificateValue" :disabled="!enableDisableCertificationOption"/>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>

            <div class="row vertical-align margin-bottom-2Perc" v-if="false">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Upload Certificate
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <p><input type="file" id="certificateFile" accept=".pdf" @change="enableOrDisableFileUrl" @blur="enableOrDisableFileUrl" @focus="enableOrDisableFileUrl"></p>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Certification Date
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="text" class="form-control" v-model="certificationDateValue">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>

            <div class="row vertical-align margin-bottom-2Perc" v-if="false">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-left-0Px text-align-right">
                  <span v-if="false">Enable Certification</span>
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px text-align-left">
                  <div class="form-group" v-if="false">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="checkbox" v-model="enableCeritificationValue" :disabled="!enableDisableCertificationOption"/>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Certificate Title
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <input type="text" class="form-control" v-model="certificationTitleValue">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
            </div>
            <hr width="94%" size="10px">
            <div class="row margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px margin-Top-2Perc">
                  Progress Buckets
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                      <div class="col-sm-12 col-md-12 col-lg-12">
                        <add-progress-bucket :maxActionCount="getMaxActionCountValue" :minActionCount="getMinActionCountValue" :maxElectiveEnrollmentCount="getMaxElectiveEnrollmentCount" :cohortName="getCohortName" :groupName="groupName" :certificateTitle="certificateTitle" :certificationDate="certificationDate" :createBtnPressed="IsCreateButtonPressed" :unreleasedModuleMessage="getUnreleasedModuleMessage" :showUnreleasedModuleMessage="getShowUnreleasedModuleMessage" @addBuckets="addBuckets" ></add-progress-bucket>
                      </div>
                    </div>
                </div> 
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createGroupInternal">Create Group</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { groupService } from '@/server-util/group-service'
import addProgressBucket from '@/components/AddProgressBucket'
export default {
  created: function () {
    this.setDefaultValue()
  },
  data: function () {
    return {
      constants: constants,
      enableDisableCertificationOption: false,
      showAlertDialog: false,
      errorMsg: '',
      groupName: '',
      showUnreleasedModuleMessage: false,
      UnreleasedModuleMessage: '',
      maxElectiveEnrollmentCount: 0,
      cohortName: '',
      isGroupCreatedSuccessfully: false,
      createButtonPressed: false,
      progressBuckets: [],
      isPublic: false,
      certificationEnabled: false,
      certificateTitle: null,
      certificationDate: null,
      Certificate: null,
      display_title_maxLength: constants.Group_Course_Display_Title_Max_Length,
      selectedOperation: '',
      allowView: false,
      minActionCount: 0,
      maxActionCount: 0
    }
  },
  name: 'CreateGroupDiv',
  methods: {
    enableOrDisableFileUrl (event) {
      var file = document.getElementById('certificateFile').files[0]
      if (file !== undefined && file !== 'undefined' && file !== null && file !== 'null' && file !== '') {
        this.enableDisableCertificationOption = true
      } else {
        this.certificationEnabled = false
        this.enableDisableCertificationOption = false
      }
    },
    setDefaultValue: function () {
      this.$store.state.createProgressBuckets = []
      this.progressBuckets = []
      this.maxElectiveEnrollmentCount = 0
      this.cohortName = ''
    },
    updateHideCreateGroupOverlayFlag: function (event, flagToUpdate) {
      this.$emit('updateFlag', flagToUpdate)
    },
    addBuckets: function (value) {
      var _this = this
      if (value) {
        _this.progressBuckets = _this.$store.state.createProgressBuckets
        setTimeout(function () {
          _this.createGroup()
        }, 100)
      } else {
        _this.createButtonPressed = false
      }
    },
    createGroupInternal: function () {
      console.log('CREATE GROUP INTERNAL ', this.createButtonPressed)
      this.createButtonPressed = true
    },
    createGroup: function () {
      if (this.createButtonPressed === false) {
        return
      }
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        var _this = this
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          this.$emit('showSpinner', true)
          var certificateFile = null // document.getElementById('certificateFile').files[0]
          const formData = new FormData()
          formData.append('CertificateTitle', _this.certificateTitle)
          formData.append('CertificationDate', _this.certificationDate)
          if ((certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && certificateFile !== 'null' && certificateFile !== '')) {
            formData.append('CertificateFile', certificateFile)
            formData.append('AllowView', _this.allowView)
          } else {
            formData.append('CertificateFile', null)
            formData.append('AllowView', false)
            _this.certificationEnabled = false
          }
          // AK: Check wheather user has added Unreleased lesson text? If not then keep it null and set show value to false.
          if (this.UnreleasedModuleMessage === undefined || this.UnreleasedModuleMessage === 'undefined' || this.UnreleasedModuleMessage === null || this.UnreleasedModuleMessage === 'null' || this.UnreleasedModuleMessage.trim().length === 0) {
            this.showUnreleasedModuleMessage = false
            this.UnreleasedModuleMessage = null
          }
          var groupObj = {
            GroupName: this.groupName,
            M365Enabled: false,
            M365CourseMasterId: constants.Empty_Guid,
            ProgressBuckets: this.progressBuckets,
            IsPublic: this.getIsPublicValue,
            CertificationEnabled: this.certificationEnabled,
            ShowUnreleasedModuleMessage: this.getShowUnreleasedModuleMessage,
            UnreleasedModuleMessage: this.getUnreleasedModuleMessage,
            MaxElectiveEnrollmentCount: parseInt(this.getMaxElectiveEnrollmentCount) === 0 ? null : parseInt(this.getMaxElectiveEnrollmentCount),
            CohortName: parseInt(this.getMaxElectiveEnrollmentCount) === 0 ? null : this.getCohortName,
            MinActionCount: this.getMinActionCountValue,
            MaxActionCount: this.getMaxActionCountValue
          }
          formData.append('GroupInfo', JSON.stringify(groupObj))
          groupService
            .createGroup(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide showing Spinner
                this.$emit('showSpinner', false)
                // AK: Store it
                storeObj.state.groupList.push(responseObj.data)
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.groupName + '\' group created successfully.'
                this.isGroupCreatedSuccessfully = true
                storeObj.state.createProgressBuckets = []
                _this.progressBuckets = []
                _this.groupName = ''
                _this.createButtonPressed = false
              } else {
                // AK: Hide Spinner
                this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                _this.createButtonPressed = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
              _this.createButtonPressed = false
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW GROUP'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isGroupCreatedSuccessfully) {
        // AK: Hide Create Group Overlay
        this.$emit('updateFlag', true)
        this.isGroupCreatedSuccessfully = false
      }
    },
    validateGroupName: function () {
      if (/^(\w+\s?)*\s*$/.test(this.groupName)) {
        return true
      }
      return false
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.groupName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Name can\'t be empty.'
        return false
      } else if (this.groupName.match(/[!@#$%^&*()_+\-=[\]{};':"\\|,<>/?]/)) {
        this.showAlertDialog = true
        this.errorMsg = 'Special character(s) are not allowed in the name.'
        return false
      } else if (!this.validateGroupName()) {
        this.showAlertDialog = true
        this.errorMsg = 'More than one white space in between the name is not allowed.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'add-progress-bucket': addProgressBucket
  },
  computed: {
    getMaxElectiveEnrollmentCount: {
      get: function () {
        return this.maxElectiveEnrollmentCount
      },
      set: function (newValue) {
        this.maxElectiveEnrollmentCount = parseInt(newValue)
        this.cohortName = this.maxElectiveEnrollmentCount > 0 ? this.cohortName : ''
      }
    },
    getCohortName: {
      get: function () {
        return this.cohortName
      },
      set: function (newValue) {
        this.cohortName = newValue
      }
    },
    getUnreleasedModuleMessage: {
      get: function () {
        return this.UnreleasedModuleMessage
      },
      set: function (newValue) {
        this.UnreleasedModuleMessage = newValue
      }
    },
    getShowUnreleasedModuleMessage: {
      get: function () {
        return this.showUnreleasedModuleMessage
      },
      set: function (newValue) {
        this.showUnreleasedModuleMessage = newValue
      }
    },
    getMinActionCountValue: {
      get: function () {
        return this.minActionCount
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Min Action count must be positive value.'
          } else {
            this.minActionCount = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Min Action must be a non empty digit value.'
        }
      }
    },
    getMaxActionCountValue: {
      get: function () {
        return this.maxActionCount
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Max Action count must be positive value.'
          } else {
            this.maxActionCount = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Max Action must be a non empty digit value.'
        }
      }
    },
    allowViewCertificateValue: {
      get: function () {
        return this.allowView
      },
      set: function (newValue) {
        this.allowView = newValue
      }
    },
    IsCreateButtonPressed: {
      get: function () {
        return this.createButtonPressed
      }
    },
    getIsPublicValue: {
      get: function () {
        return this.isPublic
      },
      set: function (newValue) {
        this.isPublic = newValue
      }
    },
    certificationDateValue: {
      get: function () {
        return this.certificationDate
      },
      set: function (newValue) {
        this.certificationDate = newValue
      }
    },
    certificationTitleValue: {
      get: function () {
        return this.certificateTitle
      },
      set: function (newValue) {
        this.certificateTitle = newValue
      }
    },
    enableCeritificationValue: {
      get: function () {
        return this.certificationEnabled
      },
      set: function (newValue) {
        this.certificationEnabled = newValue
      }
    }
  },
  watch: {
    getShowUnreleasedModuleMessage: function (newValue, oldValue) {
      this.getUnreleasedModuleMessage = newValue ? '' : ''
    }
  }
}
</script>

<style scoped>
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left !important;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 15%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border:1px solid red;
}
.float-left {
  float: left;
}
</style>





// WEBPACK FOOTER //
// src/components/group/CreateGroupOverlay.vue